var _style, _ellipse, _line, _line2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalorieCarb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#192852;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 20.2,
    cy: 20.6,
    rx: 17.8,
    ry: 17.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.6,
    y1: 33.2,
    x2: 14.3,
    y2: 26.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 32.7,
    y1: 7.8,
    x2: 26.6,
    y2: 14.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,19.3c0,0,4.3-6.2,11.7-6.5c2,0,9,0.3,13.4,6.9c0.5,1,2.8,3.9-4.4,5.6c-1.8,0.3-7.8,1.8-17.4,0 C9.8,24.9,4.7,23.4,7.6,19.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,15.2c0,0,0.6,3.1,2.3,4.2c0.7,0.3,2.5,0.8,3.2-2.1c0.7-2.9,0.2-3.2,0.5-4.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,13c0,0-0.4,3.5,1.8,5.7c0.5,0.5,2.4,2.2,4.6-3.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalorieCarb);
export default __webpack_public_path__ + "static/media/CalorieCarb.61272d1516136b94b0068344e433e7ca.svg";
export { ForwardRef as ReactComponent };